import { useLingui } from '@lingui/react/macro';

import { Error } from './error.js';

export function NotFoundPage() {
  const { t } = useLingui();

  return (
    <Error
      statusCode={404}
      title={t`Not found`}
      description={t`The page you are looking for does not exist.`}
    />
  );
}
